/**
 * The widget deep link for a mailed login link
 * (/widget-email-login#session=…&token=…). The token sits in the fragment so
 * that mail scanners fetching the link never send it anywhere; this page only
 * passes it on to the widget on the same computer, which redeems it with the
 * verifier it alone holds.
 */

const SESSION_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const TOKEN_RE = /^[A-Za-z0-9_-]{20,128}$/;

export function widgetDeepLink(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const session = params.get("session") ?? "";
  const token = params.get("token") ?? "";
  if (!SESSION_RE.test(session) || !TOKEN_RE.test(token)) return null;
  const link = new URLSearchParams({ session, token });
  return `carmen://email-login?${link.toString()}`;
}
